define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({
        supportModel: true,

        initialize: function (constructorData) {
            if (constructorData) {
                this.modelController = constructorData.modelController;
                this.model = constructorData.model;
                this.visitorId = constructorData.visitorId;
            }
            this.getModelFuncName = this.modelController ? "getModelParam" : "get";
            this.bindModelFuncName = this.modelController ? "bindModelParam" : "bind";
            this.unbindModelFuncName = this.modelController ? "unbindModelParam" : "unbind";
        },

        bindModel: function (request) {
            if (!request.modelPath || ((request.callback && request.callback === 'function') && (request.selector && request.attribute))) {
                return;
            }

            var that = request.context || this;

            var modelCtrl = request.modelController || this.modelController || this.model;

            if (!modelCtrl) {
                return {error: "Unable to find the modelController to bind to param [" + request.modelPath + "]"};
            }

            modelCtrl[this.bindModelFuncName](request.modelPath, request.callback, that, request.trigger);
        },

        unbindModel: function (request) {
            var context = request && request.context ? request.context : this;
            var callback = request && request.callback ? request.callback : null;
            var modelPath = request && request.modelPath ? request.modelPath : null;

            var modelCtrl = this.modelController || this.model;
            modelCtrl[this.unbindModelFuncName](modelPath, callback, context);
        },
        getModelParam: function (modelPath) {
            var ctrl = this.modelController || this.model;
            return ctrl[this.getModelFuncName](modelPath);
        },

        dispose: function () {
            var modelCtrl = this.modelController || this.model;
            if (modelCtrl) {
                modelCtrl[this.unbindModelFuncName](null, null, this);
            }
        }
    });

    // todo - what to export?

});
